import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("auralift_cookie_consent")) setShow(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem("auralift_cookie_consent", choice);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:max-w-md z-[1000]" data-testid="cookie-banner">
      <div className="bg-white rounded-2xl border border-brand-border/60 shadow-[0_12px_40px_rgba(74,93,82,0.18)] p-5">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-9 h-9 rounded-full bg-brand-primary/10 flex items-center justify-center shrink-0">
            <Cookie className="w-4 h-4 text-brand-primary" strokeWidth={1.5} />
          </div>
          <p className="text-sm text-brand-slate leading-relaxed">
            We use essential cookies to keep you signed in and improve AuraLift. See our{" "}
            <Link to="/legal" className="text-brand-primary underline">Privacy &amp; Terms</Link>.
          </p>
        </div>
        <div className="flex items-center gap-2 justify-end">
          <Button data-testid="cookie-decline" onClick={() => decide("essential")} variant="ghost" size="sm" className="rounded-full text-brand-slate">
            Essential only
          </Button>
          <Button data-testid="cookie-accept" onClick={() => decide("all")} size="sm" className="rounded-full bg-brand-primary hover:bg-brand-primaryHover text-white">
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
};
